'use strict';

var React = require('react');

var SvgChatMajor = function SvgChatMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 8a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 9.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 8.75a4.75 4.75 0 0 1 4.75-4.75h4.5a4.75 4.75 0 0 1 4.75 4.75v.75a4.75 4.75 0 0 1-4.75 4.75h-1.626l-3.178 2.353a.75.75 0 0 1-1.196-.603v-1.992a4.751 4.751 0 0 1-3.25-4.508v-.75Zm4.75-3.25a3.25 3.25 0 0 0-3.25 3.25v.75a3.251 3.251 0 0 0 2.64 3.193.75.75 0 0 1 .61.737v1.082l2.18-1.615a.75.75 0 0 1 .447-.147h1.873a3.25 3.25 0 0 0 3.25-3.25v-.75a3.25 3.25 0 0 0-3.25-3.25h-4.5Z"
  }));
};
SvgChatMajor.displayName = "ChatMajor";

exports.SvgChatMajor = SvgChatMajor;
